var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.957068 0.00401635C1.04732 0.00388261 1.13669 0.0235009 1.22005 0.0617393C1.3034 0.0999777 1.37907 0.156079 1.44271 0.226807L4.95809 4.11147C5.06445 4.22905 5.19073 4.32232 5.32971 4.38596C5.4687 4.44959 5.61766 4.48234 5.7681 4.48234C5.91854 4.48234 6.0675 4.44959 6.20648 4.38596C6.34547 4.32232 6.47175 4.22905 6.57811 4.11147L10.088 0.23187C10.1514 0.159329 10.2272 0.101468 10.3111 0.0616623C10.3949 0.0218569 10.4851 0.000905016 10.5763 2.8677e-05C10.6676 -0.000847662 10.7581 0.0183692 10.8425 0.0565582C10.927 0.0947472 11.0037 0.151143 11.0682 0.222456C11.1328 0.293769 11.1838 0.37857 11.2184 0.471912C11.2529 0.565253 11.2703 0.665265 11.2695 0.766113C11.2687 0.866961 11.2498 0.966624 11.2137 1.05929C11.1777 1.15195 11.1254 1.23576 11.0597 1.30582L7.54984 5.18542C7.07699 5.70704 6.43619 6 5.7681 6C5.10001 6 4.45921 5.70704 3.98635 5.18542L0.470971 1.30076C0.374798 1.19454 0.309296 1.05917 0.282753 0.911798C0.256211 0.764422 0.269821 0.611655 0.321861 0.47283C0.373901 0.334005 0.462032 0.215359 0.575103 0.131908C0.688174 0.0484559 0.821102 0.00394823 0.957068 0.00401635Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowAdmin);
export default __webpack_public_path__ + "static/media/down_arrow_admin.4ef9e717f44ac47fc09eb6a624d16398.svg";
export { ForwardRef as ReactComponent };